module.exports = __webpack_public_path__ + "img/ClownofPrizesInkBlue.c2a2249d.png";